import { http } from 'http';

export default {
  validateCookie: id => http.get(`/bconnect/validatecookie/${id}`),

  getStateProcess: params =>
    http.get(`/bconnect/stateprocess/${params.identityCard}/${params.email}/${params.id}`),

  operationByGUID: guid => http.get(`/bconnect/operations/${guid}`),

  precontractByGUID: guid => http.get(`/masterdata/precontract/${guid}`),

  precontractByCampaignId: campaignId => http.get(`/masterdata/precontract/campaign/${campaignId}`),

  errorKOByGUID: guid => http.get(`/bconnect/error/${guid}`),

  campaignFront: params =>
    http.get(
      `/bconnect/campaignfront?id=${params.id}&partnerid=${params.partnerid}&idc=${params.idc}`
    ),

  componentsByPartnerId: (id, partnerId) =>
    http.get(`/cms/${process.env.APP_LOCALE}/templates/${id}/patterns`, {
      headers: { AppId: process.env.APP_ID, PartnerId: partnerId }
    }),

  campaignFrontByGuid: guid => http.get(`/bconnect/campaignfront/${guid}`),

  getMasterData: () => http.get('/masterdata'),

  legalConditions: params => http.get(`/campaigns/${params.idOffer}/consentsgroups/${params.step}`),

  documentsRequiredByGuid: guid => http.get(`/bconnect/documentsrequired/${guid}`),

  getTownsByCp: cp => http.get(`/bconnect/townsbycp/${cp}`)
};
